// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Summary__summaryContainer___1rQd4{position:relative;width:100%;height:100%}.Summary__progressBar___1bCcn{position:absolute;top:0;left:0;width:8px;height:100%;border-top-right-radius:8px;border-bottom-left-radius:8px;overflow:hidden;background-color:#eae9e3}.Summary__progression___zvn4p{display:block;width:100%;background-color:#2d50e6;transition:height .3s}.Summary__summaryList___55aOs{padding-left:24px}.Summary__summaryList___55aOs li a{display:block;padding:12px 0;color:#6b6651;text-decoration:none;color:inherit;font-weight:400;font-size:16px;line-height:24px}.Summary__summaryList___55aOs li a:hover{text-decoration:underline}li.Summary__activeTitle___3CgMw a{color:#2d50e6}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"summaryContainer": "Summary__summaryContainer___1rQd4",
	"progressBar": "Summary__progressBar___1bCcn",
	"progression": "Summary__progression___zvn4p",
	"summaryList": "Summary__summaryList___55aOs",
	"activeTitle": "Summary__activeTitle___3CgMw"
};
module.exports = ___CSS_LOADER_EXPORT___;
